/**
 * Fetch EmployeeList
 */

export async function fetchEmployeeList(accessToken: string, employeeName: string) {
  // Trim and encode the employee name to handle spaces and special characters
  const trimmedName = employeeName.trim();
  const encodedName = encodeURIComponent(trimmedName);
  
  const url = `https://bectors.sharepoint.com/sites/PTMS_PRD/_api/web/lists/getbytitle('EmployeeList')/items?$filter=EmployeeName/Title eq '${encodedName}'&$expand=EmployeeName,DepartmentId,RoleId,PlantId&$select=Id,Title,EmployeeName/Title,DepartmentId/Id,DepartmentId/Title,RoleId/Id,RoleId/Title,PlantId/Id,PlantId/Title`;

  console.log('=== FETCHING EMPLOYEE LIST ===');
  console.log('Searching for employee name:', trimmedName);
  console.log('Encoded name:', encodedName);
  console.log('API URL:', url);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${accessToken}`,
        "Accept": "application/json;odata=verbose",
      },
    });

    if (!response.ok) {
      const errorText = await response.text();
      console.error("=== EMPLOYEE LIST API ERROR ===");
      console.error("Status:", response.status);
      console.error("Status Text:", response.statusText);
      console.error("Response:", errorText);
      console.error("Searched for:", trimmedName);
      return [];
    }

    const data = await response.json();
    const items = data.d?.results || [];

    console.log('API returned items:', items.length);
    if (items.length === 0) {
      console.warn('No employees found matching name:', trimmedName);
      console.warn('Full API response:', data);
    }

    const employeeList = items.map((item: any) => ({
      id: item.Id,
      Title: item.Title,
      employeeName: item.EmployeeName?.Title || "N/A",
      departmentId: item.DepartmentId?.Id || null,
      departmentName: item.DepartmentId?.Title || "N/A",
      roleName: item.RoleId?.Title || "N/A",
      roleId: item.RoleId?.Id || null,
      plantId: item.PlantId?.Id || null,
      plantName: item.PlantId?.Title || "N/A",
    }));
    
    console.log('Processed employee list:', employeeList);
    console.log('=== EMPLOYEE LIST FETCH COMPLETE ===');
    
    return employeeList;
  } catch (err) {
    console.error("=== ERROR FETCHING EMPLOYEE LIST ===");
    console.error("Error:", err);
    console.error("Searched for:", trimmedName);
    return [];
  }
}



/**
 * Fetch SharePoint User ID by Email (mapped from Azure AD)
 */

export async function getSharePointUserIdByEmail(email: string, accessToken: string): Promise<number> {
  const webUrl = "https://bectors.sharepoint.com/sites/PTMS_UAT";
  const url = `${webUrl}/_api/web/siteusers?$filter=Email eq '${email}'`;

  const response = await fetch(url, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
      Accept: "application/json;odata=verbose"
    }
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(`Failed to get SharePoint User ID: ${error}`);
  }

  const json = await response.json();
  const user = json?.d?.results?.[0];

  if (!user) {
    throw new Error(`User with email ${email} not found in SharePoint site.`);
  }

  return user.Id; // ← This is the SharePoint User ID (e.g., 40)
}

